import React, {useState, useEffect} from 'react';
import GTMDataLayer from './gtm';

const FilterSearch = (props) => {

  const [isHidden, setIsHidden] = useState(true);
  const [searchButton, setSearchButton] = useState('');

  const setHiddenSate = () => {
    if (document.getElementById("searchInput").value.length > 0) {
      setIsHidden(false);
      document.getElementById("searchInput").removeAttribute('title');
    }
    else {
      setIsHidden(true);
    }

    if (document.getElementById("searchInput").value.length >= 3) {
      setSearchButton('enabled');
    }
  }

  useEffect(() => {
    setHiddenSate();
  }, [props.isReady]);

  const inputHandler = (e) => {
    e.preventDefault();
    const searchValue = document.getElementById("searchInput").value;
    if (searchValue.length >= 3) {
      props.setSearch(searchValue);
      setIsHidden(false);
    }
    else if (searchValue.length < 3 && searchValue.length > 0) {
      props.setSearch(null);
      setIsHidden(false);
      document.getElementById("searchInput").setAttribute('title', Drupal.t('The keyword must be at least 3 characters long.'));
    }
    else if (searchValue.length == 0) {
      props.setSearch(null);
      setIsHidden(true);
    }
  };

  const resetSearch = () => {
    if (document.getElementById("searchInput").value.length > 0) {
      document.getElementById("searchInput").value = '';
      props.setSearch(null);
      setIsHidden(true);
      setSearchButton('');

      // Track clear search.
      GTMDataLayer({
        event: 'incentives_filter_clear',
        pageUrl: location.href,
        search_clear: 1
      });
    };
  };

  // Handle Clear search and tags link.
  const clearSearch = (e) => {
    e.preventDefault();
    document.getElementById("searchInput").value = '';
    setIsHidden(true);
    props.setSearch(null);
    setSearchButton('');
    props.setFilters({...props.filters, search: null, industry: '', page: 0});


    // Track reset.
    GTMDataLayer({
      event: 'incentives_filter_clear',
      pageUrl: location.href,
      filter_search_reset: 1
    });
  }

  return (
    <div className='search'>
      <form className='search-form  cp-search-bar--gray' onSubmit={inputHandler}>
        <input 
          id="searchInput" 
          type="text" 
          placeholder={Drupal.t('Search')}
          defaultValue={(props.filters.search) && props.filters.search}
          onChange={setHiddenSate}
          />
          <div id="resetSearch" className={isHidden ? 'hidden' : ''} onClick={resetSearch}>X</div>
        <button className={searchButton} type="submit">{Drupal.t('Search')}</button>
      </form>
    </div>
  );
};

export default FilterSearch;